<template>
  <div id="app">
    <div style="display: flex; width: 100%; position: absolute;top: 30px;z-index: 999;">
      <img src="./assets/lg.png" style="height: 35px;display: inline-block;margin: 19px 0 0 400px;" alt="">
      <div class="nav">
        <div class="nav-a">
          <ul class="nav-a-ul">
            <li class="nav-a-li" :class="classA == index ? 'active' : ''" @click="selected(index)"
              v-for="(item, index) in configNav">
              <router-link :to='item.path' class="nav-a-text" @click="showToggle(index)">{{ item.name }}</router-link>
              <ul class="menu_ul" :class="{ 'active': index === isShow }">
                <li class="menu_li" v-for="nav in item.subItems" :class="classB == nav ? 'active' : ''"
                  @click="menuselected(nav)">
                  <router-link class="menu_ul_text" :to="nav.link" :class="{ 'active': nav.link == linkClick }"
                    @click="treeNavSwitch(nav)" style="color: #fff;">{{ nav.text }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="appWrap clear">
      <div class="content">
        <router-view />
      </div>
    </div>
    <div class="appBottom">
      <div class="appBottomtop">
        <div class="appBottomtop1">
          <ul class="appBottomtop1nav-a-ul">
            <li class="appBottomtop1nav-a-li" v-for="(item, index) in configNavs" @click="selected1(index)">
              {{ item.name }}
              <!-- <span class="nav-a-li-sapn"></span> -->
              <ul style="display: block;">
                <li v-for="nav in item.subItems" @click="menuselected(nav)" style="color: #fff;">
                  <router-link :to="nav.link" @click="treeNavSwitch(nav)">{{ nav.text }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="appBottomtop2">
          <h3>联系方式</h3>
          <p><i style="padding-right: 10px;" class="el-icon-phone"></i>{{ dataTy.phone }}</p>
          <p><i style="padding-right: 10px;" class="el-icon-message"></i>{{ dataTy.email }}
          </p>
          <p><i style="padding-right: 10px;" class="el-icon-map-location"></i>{{ dataTy.address }}</p>
          <img :src=" dataTy.qrcode " alt="" style="width: 140px;margin-top: 20px;">
        </div>
      </div>
      <div class="appBottomtopBot">
        Copyright © 鄂尔多斯市东胜区万大职业培训学校| 技术支持：内蒙古助梦网络科技有限公司15049882649


        &nbsp;&nbsp;&nbsp; <a class="icp" style="text-decoration:none;color: #fff;"
        href="https://beian.miit.gov.cn"> 蒙ICP备2022000566号-3  </a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15060202000433"
          style="display:inline-block;text-decoration:none;color: #fff;">

          蒙公网安备 15060202000433号

    
        </a>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: '1',
      topNavIndex: "/",
      show: false,
      classA: 0,
      classB: 0,
      isShow: 0,
      dataTy:{},
      linkClick: "",
      configNav: [
        {
          name: "首页",
          path: '/',
        },{
          name: "学校概况",
          path: '/schoolProfile',
          subItems: [
            { link: '/schoolProfile', text: '学校概况' },
            { link: '/teachingFacilities', text: '教学设施' },
            { link: '/honor', text: '学校荣誉' },
          ]
        },
        {
          name: "师资队伍",
          path: '/teachingStaff',
        },{
          name: "消防工程",
          path: '/serviceItems',
          subItems: [
            { link: '/serviceItems', text: '服务项目' },
            { link: '/fireEquipment', text: '消防器材' },
            { link: '/maintenance', text: '年检维修' },
          ]
        },{
          name: "培训项目",
          path: '/offerACourse',
          subItems: [
            { link: '/offerACourse', text: '开班信息' },
            { link: '/trainingLocation', text: '培训地 点' },
            { link: '/trainingProgram', text: '培训项目' },
          ]
        },{
          name: "新闻动态",
          path: '/newsInformation',
        },{
          name: "人才招聘",
          path: '/recruitments',
        },{
          name: "联系我们",
          path: '/contactUs',
        },
      ],
      configNavs: [{
          name: "学校概况",
          path: '/schoolProfile',
          subItems: [
            { link: '/schoolProfile', text: '学校概况' },
            { link: '/teachingFacilities', text: '教学设施' },
            { link: '/honor', text: '学校荣誉' },
          ]
        },
        {
          name: "师资队伍",
          path: '/teachingStaff',
          subItems: [
            { link: '/teachingStaff', text: '师资队伍' },
          ]
        },{
          name: "消防工程",
          path: '/serviceItems',
          subItems: [
            { link: '/serviceItems', text: '服务项目' },
            { link: '/fireEquipment', text: '消防器材' },
            { link: '/maintenance', text: '年检维修' },
          ]
        },{
          name: "培训项目",
          path: '/offerACourse',
          subItems: [
            { link: '/offerACourse', text: '开班信息' },
            { link: '/trainingLocation', text: '培训地点' },
            { link: '/trainingProgram', text: '培训项目' },
          ]
        },{
          name: "新闻动态",
          path: '/newsInformation',
          subItems: [
            { link: '/newsInformation', text: '新闻动态' },
          ]
        },{
          name: "人才招聘",
          path: '/recruitments',
          subItems: [
            { link: '/recruitments', text: '人才招聘' },
          ]
        },{
          name: "联系我们",
          path: '/contactUs',
          subItems: [
            { link: '/contactUs', text: '联系我们' },
          ]
        },
      ]
    };
  },
  computed: {
    topNav() {
      // 顶部导航
      return window.configUrl.menu;
    },

  },
  watch: {
    "$route.path"(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  mounted() {
    this.init();
    this.$axios
              .get("/system/contact/getContact", { })
              .then(res => {
                if (res.code == 0) {
                    this.dataTy = res.data
                    this.handler()
                } else {
                  this.$message.closeAll();
                  this.$message.error(res.msg);
                }
              });
  },
  methods: {
    selected: function (index) {
      this.classA = index;
      sessionStorage.setItem("top", index);
    },
    selected1: function (index) {
      this.classA = index + 1;
      sessionStorage.setItem("top", index + 1);
    },
    menuselected: function (nav) {
      this.classB = nav;
    },
    showToggle: function (index) {
      this.isShow = index;

    },
    treeNavSwitch: function (nav) {
      this.linkClick = nav.link;
    },
    init() {
      console.log(' sessionStorage.getItem("top") sessionStorage.getItem("top") sessionStorage.getItem("top")', sessionStorage.getItem("top"))
      if (sessionStorage.getItem("top")) {
        this.classA = sessionStorage.getItem("top");
      } else {
        this.classA = 0;
      }
    },
  }
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Microsoft YaHei;
}

html,
body {
  width: 100%;
  // height: 100%;
}

.appBottom {
  width: 100%;
  height: 490px;
  padding: 80px 0 65px;
  background: #2d3e50 none repeat scroll 0 0;
  color: #ffffff;
  list-style: none;

  .appBottomtopBot {
    background-color: #0086d1;
    width: 100%;
    line-height: 50px;
    text-align: center;
    margin-top: 60px;
  }

  .appBottomtop {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;

    .appBottomtop1 {
      width: 73%;
      height: 100%;

      .appBottomtop1nav-a-ul {
        width: 80%;
        padding: 0 10px;
        display: flex;
        justify-content: space-between;
        list-style: none;
        font-size: 20px;

        .appBottomtop1nav-a-li {
          ul {
            list-style: none;
            margin-top: 20px;

            li {
              line-height: 30px;

              a {
                font-size: 14px;
                color: #fff !important;
                text-decoration: none;
              }

              a:hover {
                color: #2589ff !important;
              }
            }
          }
        }

      }
    }

    .appBottomtop2 {
      flex: 1;

      h3 {
        margin-bottom: 30px;
      }

      p {
        padding: 10px 0;

        i {
          font-size: 20px;
        }
      }
    }
  }
}

@keyframes inputIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* 应用动画到具有.fade-in类的元素 */
.input-in {
  animation: inputIn 0.5s ease-in-out forwards;
}

.nav {
  width: 80%;
  height: auto;
  margin: 0px auto;
  border-bottom: none;
  line-height: 65px;
}

.nav-a {
  cursor: pointer;
  float: left;
  margin-left: 50px;
  letter-spacing: 4px;
  position: relative;
}

.nav-a-ul {
  list-style: none;
}

.nav-a-li {
  display: inline-block;
  margin-left: 30px;
  height: 60px;
  font-size: 20px;
  position: relative;
}

.nav-a-text {
  font-size: 18px;
  color: #fff;
  line-height: 58px;
  text-decoration: none;
}

.menu_ul {
  width: 130px;
  list-style: none;
  background: none;
  border-radius: 3px;
  z-index: 999;
  position: absolute;
  top: 58px;
  left: 0px;
  display: none;
  padding: 20px 0 0 0;
}

.menu_li {
  height: 30px;
  line-height: 30px;
  padding-left: 12px;
}

.menu_ul_text {
  font-size: 14px;
  color: #666;
  letter-spacing: 0;
  line-height: 30px;
  text-decoration: none;
  padding-left: 6px;
}

.nav-a-li:hover {
  border-bottom: 2px solid #2589ff;

  background: none;

  .nav-a-text {
    color: #2589ff !important;
  }
}

.nav-a-li.active {
  border-bottom: 2px solid #2589ff;
  background: none;

  .nav-a-text {
    color: #2589ff !important;
  }
}

/* .nav-a-li:active {
border-bottom: 2px solid #fff;
} */
.nav-a-li:hover .menu_ul {
  display: block;
}

.nav-a-li-sapn {
  position: absolute;
  width: 30px;
  height: 2px;
  background-color: #0086d1;
}

.menu_ul_text:hover {
  color: #2589ff !important
}

.menu_li.active .menu_ul_text {
  color: #2589ff;
}

.searchIcons:hover {
  background-color: #000;
  color: #000;
  cursor: pointer;
}

.el-icon-search:hover {
  cursor: pointer;
}
</style>
